var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 530 111.9",
    style: {
      enableBackground: "new 0 0 530 111.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E30613;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_83_",
    d: "M139.7,83.8c-3.1,2.5-10.6,7.2-21.4,7.2C98.8,91,83,76.4,83,55.9C83,36.5,99.3,21,118.3,21 c10.1,0,16,3.5,21.4,7.1c0.6,0.4,0.8,1.3,0.4,2l-6.2,9.5c-0.5,0.7-1.4,0.9-2.1,0.4c-1.5-1.1-6.2-4.9-13.5-4.9 c-10.8,0-19.9,9.6-19.9,20.8c0,11.4,8.7,21,19.9,21c7.8,0,10.8-3.1,13.6-4.8c0.7-0.4,1.6-0.2,2,0.5l6.3,9.2 C140.6,82.5,140.3,83.3,139.7,83.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_80_",
    d: "M179.5,90.9c-19.4,0-35.9-14.4-35.9-34.9c0-20.7,16.5-35.1,35.9-35.1c19.3,0,35.8,14.5,35.8,35.1 C215.3,76.7,198.8,90.9,179.5,90.9z M179.5,35c-11.4,0-20.5,9.6-20.5,21c0,11.3,9,20.8,20.5,20.8c11.4,0,20.5-9.5,20.5-20.8 C200,44.6,190.8,35,179.5,35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_78_",
    d: "M290.8,90h-11.4c-0.8,0-1.5-0.7-1.5-1.5V49l-13.6,23.3c-0.3,0.6-0.7,1.5-1.3,1.5h-9.7 c-0.6,0-1.1-0.9-1.4-1.5L238.3,49v39.5c0,0.8-0.7,1.5-1.5,1.5h-11.4c-0.8,0-1.5-0.7-1.5-1.5V23.4c0-0.8,0.7-1.5,1.5-1.5h12.4 c0.8,0,1.1,0.8,1.5,1.5l18.8,32l18.8-32c0.4-0.7,0.7-1.5,1.5-1.5h12.4c0.8,0,1.5,0.7,1.5,1.5v65.1C292.3,89.3,291.6,90,290.8,90z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_19_",
    d: "M338.4,69.7h-16.5v18.8c0,0.9-0.7,1.5-1.5,1.5h-11.9c-0.8,0-1.5-0.7-1.5-1.5V23.4c0-0.8,0.7-1.5,1.5-1.5 h29.9c12.8,0,23.3,9.9,23.3,23.9C361.7,59.8,351.2,69.7,338.4,69.7z M335.1,35h-13.2v21.6h13.2c6,0,11.4-3,11.4-10.8 C346.5,38,341.1,35,335.1,35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6_",
    d: "M419.6,90h-13.1c-0.9,0-1.3-0.8-1.5-1.6l-3.9-12.1h-23.3l-3.9,12.1c-0.3,0.8-0.7,1.6-1.6,1.6h-12.8 c-1,0-1.6-0.9-1.2-2L382,23.2c0.3-0.7,0.6-1.6,1.5-1.6h12.2c0.9,0,1.3,0.9,1.5,1.6l23.5,65.1C421,89.1,420.5,90,419.6,90z  M389.5,40.6L382,63.5h14.9L389.5,40.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    d: "M449.1,90.9c-11.6,0-18.3-3.9-23.5-7.7c-0.7-0.5-0.8-1.4-0.3-2l6.8-8.7c0.5-0.7,1.4-0.8,2-0.3 c2.6,1.9,6.6,5.3,14.9,5.3c9.6,0,10.3-5.6,10.3-7.3c0-6.1-9.9-7-16.3-9.4c-10.4-3.8-18.6-8.2-18.6-21c0-10.7,9.2-18.7,25.9-18.7 c9.4,0,16.1,3.5,20.4,6c0.7,0.4,0.9,1.4,0.4,2.1l-6,9.1c-0.5,0.7-1.4,0.9-2.1,0.5c-1.5-1-6.7-4.2-12.9-4.2 c-10.7,0-10.2,4.1-10.2,5.2c-0.2,5.5,10.7,7.3,20.2,10.7c9.3,3.3,15,9,15,19.7C475.1,82.3,464.6,90.9,449.1,90.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    d: "M503.6,90.9c-11.6,0-18.3-3.9-23.5-7.7c-0.7-0.5-0.8-1.4-0.3-2l6.8-8.7c0.5-0.7,1.4-0.8,2-0.3 c2.6,1.9,6.6,5.3,14.9,5.3c9.6,0,10.3-5.6,10.3-7.3c0-6.1-9.9-7-16.3-9.4c-10.4-3.8-18.6-8.2-18.6-21c0-10.7,9.2-18.7,25.9-18.7 c9.4,0,16.1,3.5,20.4,6c0.7,0.4,0.9,1.4,0.4,2.1l-6,9.1c-0.5,0.7-1.4,0.9-2.1,0.5c-1.5-1-6.7-4.2-12.9-4.2 c-10.7,0-10.2,4.1-10.2,5.2c-0.2,5.5,10.7,7.3,20.2,10.7c9.3,3.3,15,9,15,19.7C529.6,82.3,519.1,90.9,503.6,90.9z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.2,
    y: 0.3,
    className: "st0",
    width: 56.4,
    height: 111.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10.5,83.7c0,10,8,18,17.9,18.1c9.9,0,17.9-8.1,17.9-18.1c0-10-8-18-17.9-18.1C18.5,65.6,10.5,73.7,10.5,83.7  M8.5,83.7c0-11.1,8.9-20.1,19.9-20.1c11,0,19.9,9,19.9,20.1c0,11.1-8.9,20.1-19.9,20.1C17.4,103.7,8.5,94.7,8.5,83.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.6,24.8c0-6.7,5.4-12.1,12-12.1c3,0,5.8,1.2,8,3l-1.3,1.5c-1.8-1.6-4.1-2.5-6.6-2.5c-5.5,0-10,4.5-10,10.1 c0,5.6,4.5,10.1,10,10.1c3,0,5.7-1.3,7.6-3.5l0,0l1.5,1.3c-2.2,2.6-5.4,4.2-9.1,4.2C21.9,36.9,16.6,31.5,16.6,24.8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.6,
    y: 10.3,
    className: "st1",
    width: 2,
    height: 66.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.2,
    y: 76.2,
    className: "st1",
    width: 35.9,
    height: 2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "10.1,65 27.7,28.6 29.5,29.5 12,65.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "27.8,29.5 29.6,28.6 47.1,65 45.4,65.9  "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30.8,84.1c0,1.2-1,2.2-2.2,2.2c-1.2,0-2.2-1-2.2-2.2c0-1.2,1-2.2,2.2-2.2C29.8,81.9,30.8,82.9,30.8,84.1"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 26.4,
    y: 8.6,
    transform: "matrix(0.6082 -0.7938 0.7938 0.6082 2.6636 25.7187)",
    className: "st1",
    width: 2,
    height: 3.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "28.1,10.3 30.5,8.4 31.7,10 29.3,11.9  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.98a44332.svg";
export { ForwardRef as ReactComponent };